import { DELETE_USER, DELETE_USER_SUCCESS, DELETE_USER_FAILURE } from "../actionTypes";

export const deleteUser = (payload) => ({
  type: DELETE_USER,
  payload,
});

export const deleteUserSuccess = () => ({
  type: DELETE_USER_SUCCESS,
});

export const deleteUserFailure = () => ({
  type: DELETE_USER_FAILURE,
});
